import { getAuthAxiosBackend } from "@/helpers/axios"

class CollegesServices {
    get(id) {
        return getAuthAxiosBackend().get('Colleges/getCollegesById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Colleges/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Colleges/addColleges', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Colleges/updateColleges/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Colleges/restoreColleges' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Colleges/softDeleteColleges/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Colleges/deleteColleges/' + id.toString())
    }
}

export default new CollegesServices()
